import type { CityService } from 'src/store/data.store'

type PricedService = Pick<CityService, 'cityPrices' | 'pricesBySalon'>

/** City price of a service: one number, "от N" when salons differ, "-" when none */
export const formatPrice = (service: PricedService, amount = 1): string | number => {
  if (service.cityPrices.length === 0) {
    return '-'
  }
  if (service.cityPrices.length === 1) {
    return service.cityPrices[0] * amount
  }
  return `от ${Math.min(...service.cityPrices) * amount}`
}

/** Price in a chosen salon, or the city price when no salon is chosen */
export const formatPriceForSalon = (
  service: PricedService,
  salonId: number | null | undefined,
  amount = 1,
): string | number => {
  if (!salonId) {
    return formatPrice(service, amount)
  }
  return service.pricesBySalon[salonId] * amount
}
